import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as khachhangConstant from '../../views/KhachHang/constants'
import * as khachhangAction from '../../views/KhachHang/actions'
import * as khoAction from './actions'
import * as khoConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { BtnPermissions } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import DiemTichLuyEdit from "../../views/KhachHang/_DiemTichLuyEdit";
import CheckboxTreeList from "../controls/_CheckboxTreeList";
class KhoEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Ten: "",
        IsActive: 1,
        StoresId: dbContext.getStoreId(),
        CapKho: 2,
        DiaChi: "",
        DienThoai: "",
        Email: "",
        GhiChu: "",
      },
      modalEditDiem: false,
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      treeNguoiDaiDien: [],
      checkedNguoiDaiDien: [],
      multipleValueNguoiDaiDien: [],
     };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "CapKho":
        item.CapKho = selectedOption.target.value
        break;
      case "TrangThai":
        item.IsActive = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { khoDetailRequest } = this.props
    let khoId = this.getParam("kho");
    var requestData = {
      KhoId: khoId || 0
    }
    return khoDetailRequest(requestData);
  }
  UpdateKho = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ma || this.state.item.Ma == "") {
      formError.Ma = 'Bạn chưa nhập mã kho';
    }
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên kho';
    }
    if (!this.state.item.DiaChi || this.state.item.DiaChi == "") {
      formError.DiaChi = 'Bạn chưa nhập địa chỉ';
    }
    if (!this.state.item.DienThoai || this.state.item.DienThoai == "") {
      formError.DienThoai = 'Bạn chưa nhập số điện thoại';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      this.props.khoUpdateRequest(item);
    }
  }
  BackToListkho = (item, e) => {
    this.props.history.push('/kho');
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "NgayKyHd":
        item.NgayKyHd = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  EditDiemTichLuy = (isChanged) => {
    this.setState({ modalEditDiem: !this.state.modalEditDiem })
    if (isChanged) {
      this.featchDetail()
    }
  }
  onHandleRemoveNguoiDaiDien = () => {
    this.setState({ multipleValueNguoiDaiDien: [] })
  }
  onHandleChoiceNguoiDaiDien = (nodesChecked) => {
    var multipleValue = [];
    let { item, checkedNguoiDaiDien, multipleValueNguoiDaiDien } = this.state
    item["NguoiDaiDien"] = ''
    item["IdNguoiDaiDien"] = null
    nodesChecked.forEach(function (node) {
      multipleValue.push(node.value);
      if (node.data) {
        item["NguoiDaiDien"] = node.data.Name || ''
        item["IdNguoiDaiDien"] = node.data.Id || null
      } else {
        multipleValue = []
        checkedNguoiDaiDien = []
      }
    });
    this.setState({ multipleValueNguoiDaiDien: multipleValue, item, checkedNguoiDaiDien })
  }
  fetchNguoiDaiDien = () => {
    const { usersListRequest } = this.props
    var requestData = {
      store_id: this.state.stores_id,
      is_only_inherit: true
    };
    return usersListRequest(requestData);
  }
  componentDidMount() {
    this.fetchNguoiDaiDien();
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.khoEdit.type == khoConstant.KHO_DETAIL_SUCCESS) {
      let { item } = nextProps.khoEdit;
      if (item.KhoId && item.KhoId > 0) {
        var checkedNguoiDaiDien = [item.IdNguoiDaiDien];
        this.setState({
          item: item,
          checkedNguoiDaiDien
        });
      }
    } else if (nextProps.khoEdit.type == khoConstant.KHO_UPDATE_SUCCESS) {
      this.props.history.push("/kho");
    } else if (nextProps.khoEdit.type == khoConstant.USERS_LIST_SUCCESS) {
      let { listUsers } = nextProps.khoEdit;
      this.setState({
        treeNguoiDaiDien: listUsers||[]
      });
    }
  }
  render() {
    const { formError, item,treeNguoiDaiDien } = this.state;
    const {
      khoEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-4">
              <Label >Mã kho (*)</Label>
              <Input type="text" name="Ma" placeholder="Mã kho" value={item.Ma || ''} readOnly={(item.KhoId|| 0)> 0 ? true: false} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ma}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Tên kho (*)</Label>
              <Input type="text" name="Ten" placeholder="Tên kho" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Cấp</Label>
              <select name="CapKho" id="CapKho" className="form-control" value={item.CapKho || 0} onChange={this.handleSelectChange.bind(this, "CapKho")}>
                <option value={2}>Kho đại lý</option>
                <option value={1}>Kho tổng</option>
              </select>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Địa chỉ</Label>
              <Input type="text" name="DiaChi" placeholder="Địa chỉ" value={item.DiaChi || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.DiaChi}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Điện thoại</Label>
              <Input type="text" name="DienThoai" placeholder="Điện thoại" value={item.DienThoai || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.DienThoai}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Email</Label>
              <Input type="text" name="Email" placeholder="Email" value={item.Email || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Email}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Chủ kho</Label>
              <CheckboxTreeList
                placeholder={`--Người đại diện--`}
                nodes={treeNguoiDaiDien}
                checked={this.state.checkedNguoiDaiDien}
                isMultiChoice={false}
                onHandleRemove={(item) => this.onHandleRemoveNguoiDaiDien(item)}
                onChoice={e => this.onHandleChoiceNguoiDaiDien(e)}
              />
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Trạng thái</Label>
              <select name="IsActive" id="IsActive" className="form-control" value={item.IsActive} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value="">--Trạng thái--</option>
                <option value={1}>Hoạt động</option>
                <option value={0}>Ngừng hoạt động</option>
              </select>
              <em className="error invalid-feedback">{formError.Status}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Ngày ký HĐ</Label></div>
              <DatePicker name="NgayKyHd" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayKyHd)} onChange={this.handleDateChange.bind(this, "NgayKyHd")} className={"form-control"} />
            </FormGroup>
            <FormGroup className="col-sm-4">
            <div><Label >Điểm tích luỹ</Label></div>
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <Input type="text" name="DiemTichLuy" disabled={true} maxLength="6" placeholder="0" value={item.DiemTichLuy || ''}/>
                </div>
                <div className={"display-table-cell"}>
                <ButtonExt noMb={true}
                  color="primary"
                  iconClass="fa-pencil"
                  displayText="Sửa"
                  btnClick={(e) => this.EditDiemTichLuy(e)}
                  permission={BtnPermissions.KhachHang.UPDATE_DIEM_TICH_LUY} />
                </div>
              </div>
            </FormGroup>
            <FormGroup className="col-sm-8">
              <Label for="descriptionText">Ghi chú</Label>
              <Input type="text" name="GhiChu" maxLength="200" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListkho()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateKho()}
              permission={BtnPermissions.NganhHang.ADD_OR_UPDATE} />
          </div>
          <DiemTichLuyEdit
              modalEditDiem={this.state.modalEditDiem}
              onClose={this.EditDiemTichLuy}
              onSave={this.props.khachhangUpdateDiemTLRequest}
              Id={item.KhoId}
              DiemTichLuy={item.DiemTichLuy}
              Loai={khachhangConstant.LoaiKhachHang.Store}
            />
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khoEdit: state.khoEdit,
})
const connected = connect(mapStateToProps, {
  khoDetailRequest: khoAction.khoDetailRequest,
  khoUpdateRequest: khoAction.khoUpdateRequest,
  khoListRequest: khoAction.khoListRequest,
  khachhangUpdateDiemTLRequest: khachhangAction.khachhangUpdateDiemTLRequest,
  usersListRequest: khoAction.usersListRequest
})(KhoEdit)

const formed = reduxForm({
  form: 'khoEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Kho/KhoEdit.js